import { AHSeparator, Box, useTheme } from "arkh";
import React, { ReactNode } from "react";
import { useSizeClass } from "../../../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";

type Props = {
  settings?: ReactNode;
  preview: ReactNode;
};

export function WidgetScreen(props: Props) {
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  if (isCompact) {
    return <WidgetScreenCompact {...props} />;
  }
  return <WidgetScreenRegular {...props} />;
}

function WidgetScreenRegular(props: Props) {
  const theme = useTheme();

  return (
    <Box style={{ flex: 1, flexDirection: "row" }}>
      {props.settings ? (
        <Box
          style={{
            flex: 1,
            borderRightWidth: 1,
            borderRightColor: theme["border-primary"],
          }}
          color="background"
        >
          {props.settings}
        </Box>
      ) : null}
      <Box
        style={{
          flex: 1,
        }}
        color="surface"
      >
        {props.preview}
      </Box>
    </Box>
  );
}

function WidgetScreenCompact(props: Props) {
  return (
    <Box style={{ flex: 1 }} color="background">
      {props.settings ? (
        props.settings
      ) : (
        <Box color="surface">{props.preview}</Box>
      )}
      {props.settings ? (
        <>
          <AHSeparator />
          <Box color="surface">{props.preview}</Box>
        </>
      ) : null}
    </Box>
  );
}
